import request from '@/utils/request'

let DistributionApi = {
  /*列表*/
   getData(data) {
    return request._post('/shop/plus.distribution.distribution/index', data);
  },
   getSetting(data) {
    return request._get('/shop/plus.distribution.distribution/setting', data);
  },
   saveSetting(data) {
    return request._post('/shop/plus.distribution.distribution/setting', data);
  },
   storeSetting(data) {
    return request._post('/shop/plus.distribution.distribution/handle', data);
  },
}
export default DistributionApi;



// WEBPACK FOOTER //
// ./src/api/distribution.js